import { render, staticRenderFns } from "./ScorePin.vue?vue&type=template&id=03733679&scoped=true&"
import script from "./ScorePin.vue?vue&type=script&lang=ts&"
export * from "./ScorePin.vue?vue&type=script&lang=ts&"
import style0 from "./ScorePin.vue?vue&type=style&index=0&id=03733679&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03733679",
  null
  
)

export default component.exports